<template>
  <addons />
</template>

<script>
import Addons from '@/components/Services/Hosting/Common/HostingAddons'

export default {
  name: 'AddonsView',
  components: { Addons }
}
</script>
